export const enum UpdateEmailSteps {
  VERIFY_PHONE_OTP = 0,
  ENTER_EMAIL = 1,
}

export const enum UpdatePhoneSteps {
  VERIFY_EMAIL = 0,
  ENTER_PHONE = 1,
  VERIFY_PHONE_OTP = 2,
}

export const enum ProfileUpdateLocalStorageItems {
  UPDATE_PROFILE_PHONE_NUMBER_CHANGED = "UPDATE_PROFILE_PHONE_NUMBER_CHANGED",
  UPDATE_PROFILE_EMAIL_CHANGED = "UPDATE_PROFILE_EMAIL_CHANGED",
}
